import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Autocomplete, Box, Button, Grid, Select, TextField, Tooltip, Typography } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormik } from "formik";
import * as yup from "yup";
import style from './Lab.module.scss'
import { CMLabel } from '../Form/FormLabels';
import { FlexDiv } from '../Flex/Flex';
import LabModel from './LabModel';
import { CMButton, CMLinkButton } from '../Button/Button';
import { useEffect } from 'react';
import { Dropdown } from 'reactstrap';
import { buttonStyle } from '../Helpers/InlineStyles';
import { CMAutoComplete } from '../AutoComplete/AutoComplete';
import { useNavigate, useParams } from 'react-router';
import { PageRoutes } from '../../../constants';
import { toast } from 'react-toastify';
import { addLab, editLab, getByLabId, labAddDropdown, labDropdown, listLab } from '../../../Pages/Lab/LabServices';

interface Column {
    id: 'lab_test_name' | 'test_date' | 'result';
    label: string;
    minWidth?: number;
    align?: 'left';
    format?: (value: number) => string;
}

const columns: readonly Column[] = [
    {
        id: 'lab_test_name',
        label: 'Test Name',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'test_date',
        label: 'Test Date',
        minWidth: 170,
        align: 'left',
    },
    {
        id: 'result',
        label: 'Result',
        minWidth: 170,
        align: 'left',
    },

];

interface Data {
    lab_test_name: string;
    test_date: string;
    result: string;
}
const LabTable = (props: any) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [labPatientDrop, setLabPatientDrop] = React.useState([]);
    const [openModal, setOpenModal] = React.useState(false);
    const [tableData, setTableData] = React.useState<any>([]);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [SelectedRowData, setSelectedRowData] = React.useState<any>();
    const [index, setIndex] = React.useState<any>(null)
    const [patientName, setPatientName] = React.useState<any>([])
    const [labDrop, setLabDrop] = React.useState<any>([])
    const history = useNavigate();
    const { id } = useParams();

    useEffect(() => {


        if (id) {
            getByLabId(id + "").then((res: any) => {
                setSelectedRowData(res);
                // setTableData(res)
                formik.setValues(res);

                labAddDropdown().then((labAddResponse: any) => {
                    setLabDrop(labAddResponse);
                    const val:any = res?.lab_details;
                    for (let i = 0; val?.length > i; i++) {
                        const labTestId = val[i]?.lab_test_name;
                        console.log(res,"zdsdres");
                        if (labTestId) {
                            // const labTest = labAddResponse?.find((e: any) => e.id == labTestId)?.label;

                            val[i].lab_test_name = labTestId;
                        console.log(res,"zdsdres",labTestId);
                        } else {
                            console.warn("Lab Test ID not found or is empty.");
                        }
                    }
                    setTableData(val)          
                })

                labDropdown().then((response: any) => {
                    setPatientName(response);
                    let val: any = response.find((e: any) => e.label === res?.patient_id).label;
                    formik.setFieldValue('patient_id', val);
                })

            })
        } else {

            listLab().then((response: any) => {
                let roomsList = response.data.map((item: any) => item.patient_id)
                console.log(roomsList, 'roomsList')
                labDropdown().then((res: any) => {
                    console.log(res, 'res')
                    setLabPatientDrop(res);
                    let unmatchedData = res.filter((e: any) => {
                        return !roomsList.some((room: any) => room === e.label);
                    });
                    setPatientName(unmatchedData);

                })
            })
            labAddDropdown().then((labAddResponse: any) => {
                setLabDrop(labAddResponse);
            })
        }

    }, []);


    // useEffect(() => {
    //     if (id) {
    //       
    //             labDropdown().then((response: any) => {
    //                 setPatientName(response)
    //                 response.map((e: any) => {
    //                     if (e.id == res.contact_number) {
    //                         formik.setFieldValue('contact_number', e)
    //                     }
    //                 })
    //             })
    //         }, (error: any) => {
    //             console.log(error)
    //         });
    //     }
    // }, []);

    const handleShow = () => {
        setOpenModal(true);
    };

    const Edithandle = (rowData: any, index: any) => {
        setOpenEditModal(true);
        setSelectedRowData(rowData);
        setIndex(index)
    };

    const handledit = (selectedRowData: any) => {
        if (typeof selectedRowData?.lab_test_name == 'number') selectedRowData.lab_test_name = labDrop?.find((e: any) => e.id == selectedRowData.lab_test_name).label
        tableData[index] = selectedRowData;
    }
    const handleDelete = (index: any) => {
        const updatedRecords = tableData.filter((v: any, i: any) => index !== i);
        setTableData(updatedRecords);
    };
    const [options, setOptions] = React.useState([]);
    const [selectedOption, setSelectedOption] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');

    const handleSelectOption = (option: any) => {
        setSelectedOption(option);
        setOptions(options.filter((opt) => opt !== option));
        setInputValue('');
    };

    const filteredOptions = options?.filter((option: any) => {
        option.toLowerCase().includes(inputValue.toLowerCase())
    }
    );

    const handleClose = () => setOpenModal(false);
    const handleCloseedit = () => setOpenEditModal(false);
    const handleAddRow = (newRow: any) => {
        if (typeof newRow?.lab_test_name == 'number') newRow.lab_test_name = labDrop?.find((e: any) => e.id == newRow.lab_test_name).label
        const updatedData = ([...tableData, newRow]);
        setTableData(updatedData);
        formik.setFieldValue('lab_details', updatedData)
        localStorage.setItem('lab', JSON.stringify(updatedData));
    }
    const handleDropdownChange = (fields: any, e: any) => {
        formik.setFieldValue(fields, e.label)
    }
    const formik: any = useFormik({
        initialValues: {
            patient_id: SelectedRowData?.patient_id ? SelectedRowData?.patient_id : '',
            lab_details: "",
        },
        validationSchema: yup.object({
            patient_id: yup.string().required('Patient ID is required!'),
        }),
        onSubmit: (values: any) => {
            if (id) {
                // if(! lab_test_name dropdown changes){
                // values.contact_number=patientName.find((e:any)=>e.label == values.contact_number).id
                // for(let i=0;values.lab_details>i;i++){
                //     values.lab_details[i].lab_test_name=labDrop.find((e:any)=>e.label == values.lab_details[i].lab_test_name).id
                // }
                // }else{
                editLab(values, id).then((res: any) => {
                    formik.setValues(res)
                    toast.success("Record Updated Successfully")
                    history(PageRoutes.LAB_LIST);
                }, (error: any) => {
                    console.log(error)
                });
                //}
            } else {
                addLab(values).then((res: any) => {
                    toast.success("Record Created Successfully")
                    history(PageRoutes.LAB_LIST);
                }, (error: any) => {
                    console.log(error)
                });
            }
        }
    });



    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3} xs={12} sm={12} md={12} lg={12}>

                    {props?.EDIT == "EDITLAB" ? <Grid item xs={12} sm={12} md={12} lg={12}>
                        <CMLabel>Patient ID</CMLabel>
                        <CMAutoComplete
                            // {...filteredOptions?.map((option: any, index: any) => (
                            //     <li key={index} onClick={() => handleSelectOption(option)}>
                            //         {option}
                            //     </li>
                            // ))}
                            options={patientName}

                            disabled={true} placeholder="Enter Patient ID" name="patient_id"
                             value={formik?.values?.patient_id} 
                             onChange={(e: any) => handleDropdownChange("patient_id", e)} errors={formik.touched.patient_id && Boolean(formik.errors.patient_id)}
                            helperText={formik.touched.patient_id && formik.errors.patient_id} />
                    </Grid> :
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <CMLabel>Patient ID</CMLabel>
                            <CMAutoComplete options={patientName} disabled={false} placeholder="Enter Patient ID" name="patient_id"
                             value={formik?.values?.patient_id  || ""} onChange={(e: any) => handleDropdownChange("patient_id", e)} errors={formik.touched.patient_id && Boolean(formik.errors.patient_id)}
                                helperText={formik.touched.patient_id && formik.errors.patient_id} />
                        </Grid>}

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 1, mb: 2 }} >
                            <Button variant='contained' value="ADD" color='primary' onClick={handleShow}> ADD</Button>
                        </Grid>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    align={column.align}
                                                    style={{ minWidth: column.minWidth }}
                                                    className={style.labtablebg}
                                                >
                                                    <Typography><b>{column.label}</b></Typography>
                                                </TableCell>
                                            ))}
                                            <TableCell
                                                key={'action'}
                                                className={style.labtablebg}>
                                                <Typography><b>Action</b></Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {tableData?.map((row: any, index: number) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                                    {columns.map((column) => {
                                                        const value: any = row[column.id];
                                                        return (
                                                            <TableCell
                                                                key={column.id}
                                                                align={column.align}>
                                                                {column.format && typeof value === 'number'
                                                                    ? column.format(value)
                                                                    : value}
                                                            </TableCell>

                                                        );
                                                    })}

                                                    <TableCell key={"action"} >
                                                        <FlexDiv>
                                                            <Typography sx={{ marginLeft: "10px" }}>
                                                                <Tooltip title="Edit">
                                                                    <Button className={style.buttonadj} variant="outlined" value="edit" color='primary' size="small" onClick={() => Edithandle(row, index)} >Edit</Button>
                                                                </Tooltip>
                                                                {/* <Tooltip title="Delete" sx={{ marginLeft: "5px" }}>
                                                                    <Button className={style.buttonadj} variant="outlined" value="delete" color='error' size="small" onClick={() => handleDelete(index)}>Delete</Button>

                                                                </Tooltip> */}
                                                            </Typography>
                                                        </FlexDiv>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        {
                                            !tableData?.length ?
                                                <TableCell align='center' colSpan={columns.length + 1}>
                                                    No Records Found
                                                </TableCell> : null
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "end", marginTop: '10px' }}>
                            <Box component='div'
                                sx={buttonStyle}
                            >
                                <Box component='span' mr={2}>
                                    <CMLinkButton variant="contained" color="secondary" value="Cancel" link={PageRoutes.LAB_LIST} />
                                </Box>
                                <Box component='span'>
                                    <CMButton variant="contained" value="Submit" color="primary" type="submit"></CMButton>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </form>


            {openModal && <LabModel show={openModal} onHide={handleClose} header="Add Test Details" onAddRow={handleAddRow} />}
            {openEditModal && <LabModel show={openEditModal} onHide={handleCloseedit} edit={handledit} header="Update Test Details" rowData={SelectedRowData} />}




        </>
    );
}

export default LabTable;